import { useButtonColor } from '@euler/app/components/BottomAction';
import { Typography } from '@euler/app/components/typography';
import { Center } from '@euler/components/Center';
import { Icon } from '@euler/components/Icomoon';
import Euler from '@euler/components/layout';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Path, Svg } from 'react-native-svg';

export const EmptyQuotationFormView = memo(
  ({ onAdd }: { onAdd?: () => void }) => {
    const { rpx } = useResponsiveContext();
    const { bottom } = useSafeAreaInsets();
    const buttonColor = useButtonColor('primary');
    return (
      <Center flex={1} backgroundColor={'white'} pb={rpx(bottom)}>
        <EmptyIcon />
        <Typography.Text mt={rpx(15)} size={rpx(13)} light color="#333">
          当前报价单项目为空
        </Typography.Text>
        {onAdd != null && (
          <Euler.TouchableOpacity
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
            backgroundColor={buttonColor}
            height={rpx(44)}
            borderRadius={rpx(44)}
            paddingHorizontal={rpx(22)}
            mt={rpx(55)}
            onPress={onAdd}
          >
            <Icon name="add" size={rpx(20)} color="#fff" />
            <Typography.Text color="#fff">开始添加报价项目</Typography.Text>
          </Euler.TouchableOpacity>
        )}
      </Center>
    );
  },
);

const EmptyIcon = memo(() => {
  const { rpx } = useResponsiveContext();
  const size = rpx(128);
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size}>
      <Path
        d="M0 0m465.454545 0l93.09091 0q465.454545 0 465.454545 465.454545l0 93.09091q0 465.454545-465.454545 465.454545l-93.09091 0q-465.454545 0-465.454545-465.454545l0-93.09091q0-465.454545 465.454545-465.454545Z"
        fill="#c5c5c5"
      />
      <Path
        d="M707.397818 256H316.602182c-20.526545 0-37.329455 17.058909-37.329455 37.934545v436.13091c0 20.875636 16.802909 37.934545 37.329455 37.934545h313.809454C693.271273 768 744.727273 715.729455 744.727273 651.869091V293.934545c0-20.875636-16.802909-37.934545-37.329455-37.934545z m-309.364363 116.363636h134.842181c14.103273 0 25.669818 10.472727 25.669819 23.272728s-11.566545 23.272727-25.669819 23.272727h-134.842181C383.930182 418.909091 372.363636 408.436364 372.363636 395.636364s11.566545-23.272727 25.669819-23.272728zM395.636364 465.454545h186.181818c12.8 0 23.272727 10.472727 23.272727 23.272728s-10.472727 23.272727-23.272727 23.272727h-186.181818c-12.8 0-23.272727-10.472727-23.272728-23.272727s10.472727-23.272727 23.272728-23.272728z m67.234909 139.636364H398.196364C384 605.090909 372.363636 594.618182 372.363636 581.818182s11.636364-23.272727 25.856-23.272727h64.651637C477.090909 558.545455 488.727273 569.018182 488.727273 581.818182s-11.636364 23.272727-25.856 23.272727z m211.642182-65.745454l-34.816 55.156363h25.832727c1.652364 0 3.025455 1.210182 3.025454 2.722909v19.316364c0 1.489455-1.373091 2.722909-3.025454 2.722909h-40.261818v14.196364h40.168727c1.698909 0 3.048727 1.210182 3.048727 2.722909v19.316363c0 1.512727-1.349818 2.722909-3.025454 2.722909h-40.192v37.236364c0 1.512727-1.349818 2.722909-3.025455 2.722909h-33.396364c-1.675636 0-3.025455-1.210182-3.025454-2.722909v-37.12H546.909091c-1.675636 0-3.025455-1.210182-3.025455-2.722909v-19.316364c0-1.512727 1.349818-2.746182 3.025455-2.746181h38.888727v-14.196364h-38.865454c-1.698909 0-3.048727-1.210182-3.048728-2.722909v-19.316364c0-1.559273 1.349818-2.792727 3.025455-2.792727h23.621818l-34.862545-55.179636c-1.117091-1.815273 0.232727-4.072727 2.653091-4.072728h39.144727l28.718545 49.664L634.717091 535.272727h37.143273c2.327273 0 3.816727 2.210909 2.653091 4.072728z"
        fill="#FFFFFF"
      />
    </Svg>
  );
});
